<template>
  <div id="live-class" class="footer-hidden m-0 p-0">
    <div v-if="liveError.status"
      class="vx-row lg:h-full flex m-0 relative bg-black mr-2 px-20 py-32"
    >
      <div
        class="vx-col panel h-screen lg:h-full sm:h-1/2 flex-1 sm:w-1/1 p-0
          flex flex-col flex-wrap items-center justify-center
        "
      >
        <h3 class="text-danger text-center mt-20">Live is not available right now</h3>
        <div class="flex justify-center flex-wrap mt-32">
          <vs-button class="mx-2" @click="routeTo('/')">Back to home</vs-button>
          <vs-button class="mx-2" @click="routeTo('/liveschedule')">View other Live Class</vs-button>
        </div>
      </div>
    </div>
    <div v-else
      class="vx-row lg:h-full flex m-0 relative">

      <!-- Main Panel -->
      <div ref="main-panel" class="vx-col panel main-panel h-screen lg:h-full sm:h-1/2 flex-1 sm:w-1/1 p-0">
        <div class="bg-white w-full h-auto" style="position: relative;">
          <vs-button
            @click="isSidebarActive = true"
            @mouseover="isContentTabButtonActive = true"
            @mouseleave="isContentTabButtonActive = false"
            color="black"
            type="filled" class="content-tab-button p-2 pb-1 pr-5 flex-inline"
            :class="{ 'hide': isSidebarActive }"
          >
            <feather-icon class="cursor-pointer" icon="MessageCircleIcon" svgClasses="text-white stroke-current h-5 w-5 mr-2 p-0" />
            <span class="my-auto">Chat</span>
          </vs-button>

          <transition name="panel-fade" mode="out-in">
            <div key="1" class="bg-black flex justify-center items-center" style="height: calc(100vh - 180px);">
              <!-- <div v-if="vdoLoading" class="h-auto" style="min-height: calc(100vh - 180px);">
                Loading...
              </div> -->
                <!-- :title="userClassSession.currentVideoContent.nameLocal"
                :length="userClassSession.currentVideoContent.vdoLength" -->
              <VideoPlayer
                ref="videoPlayer"
                :options="{
                  ...videoOptions,
                  sources: generateVideoSource()
                }"
              />
            </div>
          </transition>
        </div>

        <!-- <div class="p-0 pt-8 bg-white" style="min-height: 500px;">
          <vs-tabs alignment="fixed">
            <vs-tab label="Overview" icon-pack="feather" icon="icon-home">
              <div class="tab-text">
                <span>วิชา {{ subject.nameLocal }} ({{ subject.code }})
                </span>

                <span>{{ subject.description }}</span>
              </div>
            </vs-tab>
            <vs-tab label="FAQ">
              <div class="tab-text">
                <span>
                  FAQ จะเปิดให้ใช้งานเร็วๆ นี้
                </span>
              </div>
            </vs-tab>
            <vs-tab label="Webboard">
              <div class="tab-text">
                <span>Webboard จะเปิดให้ใช้งานเร็วๆ นี้</span>
              </div>
            </vs-tab>
          </vs-tabs>
        </div> -->

      </div>

      <!-- Side Panel -->
      <div class="vx-col panel side-panel lg:h-full lg:w-1/3 sm:w-1/1 p-0"
        :class="{ 'hide': !isSidebarActive }"
        style="background: #eeeeee"
      >
        <div class="flex w-full bg-white p-8 justify-between">
          <span class="my-auto text-xl">Live Chat</span>
          <vs-button color="warning" icon-pack="feather" icon="icon-x" @click="isSidebarActive = false" radius ></vs-button>
        </div>
        <vs-divider class="w-full m-0 p-0 bg-grey"/>
        <!-- Live Chat Panel Content -->
        <Chat :activator="[{ feature: 'liveclass', id: currentLiveClass.id }]" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, vue/no-unused-components */
import moment from "moment";
import EventBus from '@/event-bus';
import VideoPlayer from "@/components/common-ui/video-player";
// import LiveChat from "@/views/components/live-chat";

export default {
  components: {
    VideoPlayer,
    // LiveChat,
    Chat: () => import("@/views/developing/components/chat/sidebar")
  },
  data() {
    return {
      liveError: {
        status: true,
        nolive: true,
      },
      mainPanelMode: "title", // title, video, quiz
      mainPanelWidth: window.innerWidth,
      userLiveClassSession: {
        currentVideoContent: {},
        videoWatchStat: {}
      },
      vdoLoading: true,
      vdoPlayingCount: 0,
      units: {},
      unitSeqs: [],
      isContentTabButtonActive: false,
      isSidebarActive: true,
      videoOptions: {
        autoplay: true,
        controls: true,
        fluid: false,
        nativeControlsForTouch: true,
        nativeControls: true,
        isLive: true,
        liveui: true,
      },
      stream_key: "test_live"
    }
  },
  computed: {
    learningCourse() {
      if (this.$store.state.User.currentLearningCourse) {
        return this.$store.state.User.currentLearningCourse;
      }
      return null;
    },
    student() {
      return this.$store.state.Student.profile;
    },
    teacher() {
      if (this.learningCourse) {
        return this.learningCourse.teacher;
      }
      return null;
    },
    subject() {
      if (this.learningCourse) {
        return this.learningCourse.subject;
      }
      return null;
    },
    courseOutline() {
      if (this.learningCourse) {
        return this.learningCourse.courseOutlineRegistration.courseOutline;
      }
      return null;
    },
    courseOutlineAssessments() {
      if (this.courseOutline) {
        return this.courseOutline.courseOutlineAssessments
      }
      return null;
    },
    courseOutlineUnits() {
      if (this.courseOutline) {
        return this.courseOutline.courseOutlineUnits
      }
      return null;
    },
    classSection() {
      if (this.learningCourse) {
        return this.learningCourse.classSection;
      }
      return null;
    },
    classAssignments() {
      if (this.classSection) {
        return this.classSection.classAssignments;
      }
      return null;
    },
    classMaterials() {
      if (this.classSection) {
        return this.classSection.classMaterials;
      }
      return null;
    },
    exams() {
      if (this.learningCourse) {
        return this.learningCourse.exams;
      }
      return null;
    },
    validStream() {
      if (
        this.streamPath !== null
        && this.streamPath !== ""
      ) {
        return true;
      }
      return false;
    },
    studentUnitTests() {
      if (this.learningCourse) {
        return this.learningCourse.studentUnitTests
      }
      return null
    },
    currentLiveClass() {
      return this.$store.state.LiveClass.currentLiveClass;
    }
  },
  watch: {
    'currentLiveClass'(val) {
      if (Object.keys(val).length > 0) {
        this.generateVideoSource();
      }
    }
  },
  methods: {
    routeTo(route) {
      if (route) {
        this.$router.push(route);
      }
    },
    assignemntDueDateFormatter(date) {
      if (date) {
        return moment(date).format('LLLL');
      }
    },
    setVideoEvents(vdoTopic) {
      const { id } = vdoTopic;
      const vm = this;
    },
    getVideoPlayingTime(videoWatchingId) {
      if (videoWatchingId) {
        return this.userClassSession.videoWatchStat[videoWatchingId];
      }
      return 0;
    },
    getPlayingPercent(currentTime, duration) {
      return (Math.round(currentTime / 60) * 100) / Math.round(duration / 60);
    },
    // createContentList() {
    //   if (this.courseOutlineUnits.length > 0) {
    //     this.content = this.courseOutlineUnits.map(unit => {
    //       const videoList = this.classSection.vdoSet.vdoSetUnits.filter(vdoSetUnit => vdoSetUnit.unitSeq === unit.seq)
    //       const unitTest = this.getStudentUnitTestByUnit(unit.seq);

    //       return {
    //         ...unit,
    //         test: unitTest,
    //         vdo: {
    //           ...videoList["0"]
    //         },
    //       }
    //     });
    //   } else {
    //     this.content = null;
    //   }
    // },
    generateVideoSource() {
      if (Object.keys(this.currentLiveClass).length > 0) {
        const baseStreamServer = this.currentLiveClass.rtmpServer.replace("rtmp://", "http://");
        const src = baseStreamServer + this.currentLiveClass.rtmpStream + "/manifest.m3u8";
        this.liveError.status = false;
        return [
          {
            src,
            type: "application/x-mpegURL"
          }
        ]
      }
      return [ { src: "" } ];
    }
  },
  created() {
    const _this = this;
    EventBus.$emit('toggleNav', 'close');

    setTimeout(() => {
      this.isSidebarActive = false;
    }, 300)
    // if (!this.learningCourse) {
    //   this.$router.push({ name: 'home' });
    // } else {
    //   this.createContentList();
    // }
  },
  mounted() {
    const vm = this;

    this.generateVideoSource();

    /*window.addEventListener("resize", () => {
      vm.mainPanelWidth = vm.$refs['main-panel'].scrollWidth;
    });*/

    EventBus.$on('videoPlayingCount', (val) => {
      vm.vdoPlayingCount = val.currentTime
    });

    EventBus.$on('VideoPlayer/onLoadedData', (val) => {
      // currentVideoStat.duration = val;
      this.$forceUpdate();
    });

    EventBus.$on('onVideoWatching', (val) => {
      // vm.userClassSession.videoWatchStat[vdoTopic.id].currentTime = val;
      // this.vdoPlayingCount = val;
      this.$forceUpdate();
    });

    EventBus.$on('VideoPlayer/onVideoInterrupt', (val) => {
      // currentVideoStat.duration = val.duration;
      // currentVideoStat.currentTime = val.currentTime;
      // this.setVideoStat(currentVideoStat);
    });

    EventBus.$on('VideoPlayer/onVideoError', (player) => {
      const error = player.error();
      if (error.code === 4) {
        this.liveError.status = true;
      }
      this.$forceUpdate();
    });
  },
  destroyed() {
    window.removeEventListener("resize", () => {});
  }
}
</script>

<style lang="scss">
// #screen {
//   display: flex;

//   & #sidepanel {
//     display: none;
//     width: 200px;
//     height: 100vh;

//     &.right {

//     }
//   }

// }
#screen {
  @media only screen and (min-width: 1024px) {
    height: calc(var(--vh, 1vh) * 100 - 6rem) !important;
  }
  word-break: break-word !important;
  overflow: hidden;

  & .panel {
    overflow-y: auto;
  }
}

.parentx-static {
  overflow: hidden;
  position: relative;
}

.content-tab-button {
  position: absolute;
  top: 36px;
  right: -6px;
  transition: all ease-in 300ms;
  z-index: 999;

  & .vs-button-text {
    display: inline-flex;
    align-items: center;
  }

  &.hide {
    right: -114px;
    background: rgba(0, 0, 0, 0.5) !important;
  }
}

#live-class {
  .main-panel {
    border-left: 1px solid #eeeeee !important;
    border-right: 1px solid #dddddd !important;
    overflow: hidden;
  }

  .side-panel {
    transition: all ease-out 400ms;
    // width: 0px;

    &.hide {
      width: 80px !important;
      opacity: 0;
    }
  }
}


.panel-fade-enter-active {
  transition: all .3s ease;
}
.panel-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.panel-fade-enter, .panel-fade-leave-to {
  opacity: 0;
}

.debugger {
  position: absolute;
  bottom: 0;
  background: black;
  color: white;
  min-height: 200px;
  overflow-y: scroll;
}
</style>
